import { baseUrl } from "../shared/baseUrl";

export default async function getUsersCities() {

    if (sessionStorage.getItem('cities') === null) {
        return await getCities();
    }
    else {
        return JSON.parse(sessionStorage.getItem('cities'));
    }

}

const getCities = async () => {

    var tempArr = [];
    var cities = await fetch(baseUrl + 'all-cities');
    var citiesJson = await cities.json();
    citiesJson.data.forEach((res) => {
        tempArr.push({ value: res.id, label: res.city_name });
    });
    sessionStorage.setItem('cities', JSON.stringify(tempArr));
    return tempArr;
}